<template>
  <div class="bg-white rounded-lg m-3">
    <div class="border-b-0.5 flex justify-between items-center">
      <p class="text-sm font-semibold">{{ title }}</p>
    </div>

    <div class="p-2">
      <label class="block pb-1">Assign Permissions</label>
      <div
        v-if="permissions.length > 0"
        class="grid lg:grid-cols-4 justify-start gap-y-4 w-3/4 text-sm"
      >
        <div v-for="permission in permissions" :key="permission">
          <label
            :for="resource + permission"
            class="font-bold mb-2 cursor-pointer capitalize flex gap-1 text-xs"
            v-for="resource in resources"
            :key="resource + permission"
          >
            <input
              type="checkbox"
              :id="resource + permission"
              @change="
                (isChecked) => assignEmployeeLeaveTypes(isChecked, permission)
              "
              :checked="isAssigned(permission)"
            />

            {{ permission }} {{ resource }}
          </label>
        </div>
      </div>
      <p class="text-center p-2" v-else>No Leave Types</p>
    </div>
  </div>
</template>

<script>
import { mapGetters } from "vuex";

export default {
  name: "Permissions",
  props: ["title", "data"],
  data() {
    return {
      edit_error: null,
      create_success: null,
      create_error: null,
      get_error: null,
      delete_error: null,
      delete_success: null,
      edit_success: null,
      organizationLeaveTypes: [],

      permissions: ["create", "edit", "delete"],
      resources: ["events", "announcements"],
    };
  },

  computed: {
    ...mapGetters([
      "getOrganization",
      "getToken",
      "getTabTitle",
      "getCurrentEmployeeId",
    ]),
  },

  methods: {
    assignEmployeeLeaveTypes(isChecked) {
      if (!isChecked.target.checked) {
        return;
      }
    },
    isAssigned() {},
  },

  created() {},
};
</script>
